<div class="step-content">
    <form [formGroup]="partNumbersForm" *ngIf="!isLoading; else loadingAnimation">
        <app-picklist
            *ngIf="selectedPartNumber"
            [source]="partNumbers"
            displayField="nameWithSAP"
            [disabled]="isReadOnly()"
            [formControl]="partNumbersForm.controls['equivalentPartNumbers']"
            [target]="selectedPartNumber.equivalentPartNumbers"
            formControlName="equivalentPartNumbers"
            [sourceHeader]="'admin.partNumbers.create-modal.pick-list.equivalence.leftHeader' | translate"
            [targetHeader]="'admin.partNumbers.create-modal.pick-list.equivalence.rightHeader' | translate">
        </app-picklist>
    </form>
</div>
<ng-template #loadingAnimation>
    <app-loading-spinner class="loader"></app-loading-spinner>
</ng-template>


